import React from 'react';
import { useModal } from '../hooks/useModal';
import { useNavigate, useParams } from 'react-router-dom';
import { getDeviceOS } from '../utils/deviceInfo';
import { useProfile } from '../hooks/queries/useMe';

interface GroupSettingsModalProps {
  handleOpenShareModal: () => void;
  handleEditGroup: () => void;
  handleLeaveGroup: () => void;
}

const GroupSettingsModal: React.FC<GroupSettingsModalProps> = ({
  handleOpenShareModal,
  handleEditGroup,
  handleLeaveGroup
}) => {
  const { closeModal } = useModal();
  const navigate = useNavigate();
  const deviceOs = getDeviceOS();

  const {id} = useParams<{id: string}>();

  const { data: user } = useProfile();
  const ios_installed = user?.ios_installed;
  const android_installed = user?.android_installed;

  const shouldShowDownload = (deviceOs === 'ios' && !ios_installed) || (deviceOs === 'android' && !android_installed)
  const appDownloaded = (deviceOs === 'ios' && ios_installed) || (deviceOs === 'android' && android_installed)

  const handleAppStoreClick = () => {
    const storeUrl = deviceOs === 'ios' 
      ? 'https://apps.apple.com/kr/app/%EC%97%94%EB%B9%B5-%EC%A0%95%EC%82%B0-%EC%9D%B4%EC%A0%9C%EB%8A%94-%EC%9E%8A%EC%9C%BC%EC%84%B8%EC%9A%94/id6749234696' // 실제 앱스토어 URL로 변경 필요
      : 'https://play.google.com/store/apps/details?id=com.busitdol.nbbang&hl=ko';
    
    window.open(storeUrl, '_blank', 'noopener,noreferrer');
  };

  return (
    <div className='w-full flex flex-col gap-2'>
      <h1 className='text-[22px] font-bold mb-4'>그룹 설정</h1>
      <button className='w-full p-2 text-center font-semibold bg-gray-100 rounded-lg'
        onClick={() => {
          navigate('/faq');
          closeModal();
        }}
      >FAQ</button>
      {
        shouldShowDownload && (
          <button 
            className='w-full p-2 text-center font-semibold bg-gray-100 rounded-lg relative'
            onClick={() => {
              handleAppStoreClick();
              closeModal();
            }}
          >
            {deviceOs === 'ios' ? 'iOS 앱 설치하기' : '안드로이드 앱 설치하기'}
            <span className='absolute top-1 right-2'><span className="relative flex size-2.5">
              <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-red-400 opacity-75"></span>
              <span className="relative inline-flex size-2.5 rounded-full bg-red-600"></span>
            </span></span>
          </button>
        )
      }
      {
        appDownloaded && (
          <button 
            className='w-full p-2 text-center font-semibold bg-gray-100 rounded-lg relative'
            onClick={() => {
              navigate('/mobile', { state: { goto: id }, replace: true });
              closeModal();
            }}
          >
            {deviceOs === 'ios' ? 'iOS 앱으로 열기' : '안드로이드 앱으로 열기'}
          </button>
        )
      }
      <button className='w-full p-2 text-center font-semibold bg-gray-100 rounded-lg'
        onClick={() => {
          handleOpenShareModal();
        }}
      >멤버 초대하기</button>
      <button className='w-full p-2 text-center font-semibold bg-gray-100 rounded-lg'
        onClick={() => {
          navigate(`/groups/${id}/ledger`);
          closeModal();
        }}
      >쓴 돈 모아보기</button>
      <button className='w-full p-2 text-center font-semibold bg-gray-100 rounded-lg'
        onClick={() => {
          handleEditGroup()
          closeModal()
        }}
      >그룹 수정하기</button>
      <button className='w-full p-2  text-center font-semibold bg-red-100 text-red-500 rounded-lg'
        onClick={() => {
          handleLeaveGroup()
          closeModal()
        }}
      >그룹 나가기</button>
    </div>
  );
};

export default GroupSettingsModal; 